import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToasterService } from '../shared/services/toaster/toaster.service';
import {
  ILearningPlayerRank,
  LearningPlayerCoreService,
} from '../talent-litmus-core/learning-player-core';

@Injectable({ providedIn: 'root' })
export class AsianPaintsGlobetrotterService {
  private _scientificRigourPlayers$ = new BehaviorSubject<
    ILearningPlayerRank[]
  >([]);
  get scientificRigourPlayers$(): Observable<ILearningPlayerRank[]> {
    return this._scientificRigourPlayers$.asObservable();
  }

  constructor(
    private _learningPlayersService: LearningPlayerCoreService,
    private _toast: ToasterService,
  ) {}

  public fetchScientificRigourPlayers(): void {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    this._learningPlayersService
      .getLearningPlayerLeaderboard('634d13fa04acfa00144233f1', true, 10000)
      .pipe(
        catchError((err) => {
          this._toast.showError(err.error.message);
          return of([]);
        }),
      )
      .subscribe((players: ILearningPlayerRank[]) => {
        const filteredPlayers: ILearningPlayerRank[] = [];
        console.log(players);
        players.forEach((player) => {
          player['name'] =
            (player['firstName'] || '') +
            ' ' +
            (player['lastName'] || '') +
            (player['lastname'] || '');

          if (player.extraDetail) {
            player['employeeId'] = player.extraDetail['employeeId'];
          }

          if (player['completedAt']) {
            const date = new Date(player['completedAt']);
            player['completedAt'] = `${date.getDate()} ${
              months[date.getMonth()]
            }, ${date.getFullYear()}`;
          }

          if (player['employeeId']) {
            filteredPlayers.push(player);
          }
        });

        this._scientificRigourPlayers$.next(filteredPlayers);
      });
  }
}
